import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { OnboardingSideConstants } from 'src/pages/OnboardingPage/OnboardingSide/OnboardingSideConstants';
import { COSSUPORT_DEMO_PAGE } from 'src/shared/constants';
import { COSUPPORT_URL } from 'src/constants/urls';
import { useAppSelector } from 'src/store';
import { API_VERSION } from 'src/constants/api-routes';

export const OnboardingSide = ({}) => {
  const { step } = useParams();
  const constants = OnboardingSideConstants[step] || {};
  const { promptType } = useAppSelector((s) => s.onboardingSlice);
  const [title, setTitle] = useState('');
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV2 = version === API_VERSION.V2;

  useEffect(() => {
    if (step === '4') {
      const newTitle = promptType === 'system' ? constants.title : 'System Prompt creating';

      setTitle(newTitle);
    } else {
      setTitle(constants.title);
    }
  }, [step, promptType]);

  return (
    <div className="h-full relative">
      <div
        className={
          'w-[300px] p-7 h-full flex flex-col justify-between min-h-screen overflow-y-auto overflow-x-hidden max-h-screen relative bg-[linear-gradient(23deg,#F6FFE8_0.5%,#E2FFEC_25.51%,#E2F9FF_58.74%,#E5F1FE_98.59%)]'
        }
      >
        <div className={'flex flex-col gap-12'}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="20"
              viewBox="0 0 33 20"
              fill="none"
            >
              <path
                d="M9.99343 -1.95063e-05C7.35999 -1.93923e-05 4.77036 1.05354 2.90824 2.9289C1.04613 4.80425 -3.59335e-07 7.34778 -4.41153e-07 9.99993C-5.2297e-07 12.6521 1.04613 15.1956 2.90824 17.071C4.77036 18.9463 7.36 19.9999 9.99343 19.9999L9.99343 9.99993L9.99343 -1.95063e-05Z"
                fill="#05050D"
              />
              <path
                d="M22.7539 0C28.2731 0 32.748 4.47718 32.748 10C32.748 15.5228 28.2731 20 22.7539 20C17.2348 19.9999 12.7608 15.5227 12.7607 10C12.7607 4.47727 17.2348 0.000142861 22.7539 0ZM22.7324 5.9043C20.4746 5.9043 18.6436 7.73581 18.6436 9.99512C18.6436 12.2545 20.4746 14.0859 22.7324 14.0859C24.9902 14.0858 26.8203 12.2544 26.8203 9.99512C26.8203 7.73589 24.9901 5.90444 22.7324 5.9043Z"
                fill="#05050D"
              />
            </svg>
          </div>
          <div className={'flex flex-col gap-5'}>
            <div className={'flex flex-col gap-2'}>
              {step && Boolean(+step) && (
                <p className={'font-jamjuree text-xl font-medium text-black'}>
                  Step {+step > 3 && isV2 ? +step - 1 : step}
                </p>
              )}
              <h2 className={'font-jamjuree text-2xl font-bold text-black'}>{title}</h2>
            </div>
            <p className={'font-jamjuree text-ebony_opacity_70 text-sm'}>
              {constants.description || ''}
            </p>
          </div>
        </div>
        <div className={'flex flex-col gap-2.5'}>
          <div>
            <p className={'font-jamjuree text-black text-sm font-bold'}>Need Help?</p>
          </div>
          <div className={'w-full flex flex-row justify-between'}>
            <a
              href={COSSUPORT_DEMO_PAGE}
              target={'_blank'}
              rel="noopener noreferrer"
              className={
                'flex flex-row gap-1.5 items-center border border-[rgba(5,5,13,0.10) py-2 px-4 rounded-sm-5 hover:border-[rgba(5,5,13,0.80)] transition-colors duration-300'
              }
            >
              <span className={'text-base-xs text-ebony opacity-80] select-none'}>Book a Call</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M11.3 12C9.91111 12 8.53622 11.7 7.17533 11.1C5.81444 10.5 4.57822 9.64444 3.46667 8.53333C2.35511 7.42222 1.49956 6.18889 0.9 4.83333C0.300444 3.47778 0.000444444 2.1 0 0.7V0H3.93333L4.55 3.35L2.65 5.26667C2.89444 5.7 3.16667 6.11111 3.46667 6.5C3.76667 6.88889 4.08889 7.25 4.43333 7.58333C4.75556 7.90556 5.10844 8.214 5.492 8.50867C5.87556 8.80333 6.28933 9.07822 6.73333 9.33333L8.66667 7.4L12 8.08333V12H11.3ZM2.01667 4L3.11667 2.9L2.83333 1.33333H1.35C1.40556 1.83333 1.48889 2.30289 1.6 2.742C1.71111 3.18111 1.85 3.60044 2.01667 4ZM7.98333 9.96667C8.42778 10.1556 8.87511 10.3056 9.32533 10.4167C9.77556 10.5278 10.2227 10.6 10.6667 10.6333V9.16667L9.1 8.85L7.98333 9.96667Z"
                  fill="#05050D"
                  fillOpacity="0.8"
                />
              </svg>
            </a>
            <a
              target={'_blank'}
              rel="noopener noreferrer"
              href={'mailto:support@cosupport.ai'}
              className={
                'flex flex-row gap-1.5 items-center border border-[rgba(5,5,13,0.10) py-2 px-4 rounded-sm-5 hover:border-[rgba(5,5,13,0.80)] transition-colors duration-300'
              }
            >
              <span className={'text-base-xs text-ebony opacity-80] select-none'}>Send email</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
              >
                <path
                  d="M15 1.5C15 0.675 14.325 0 13.5 0H1.5C0.675 0 0 0.675 0 1.5V10.5C0 11.325 0.675 12 1.5 12H13.5C14.325 12 15 11.325 15 10.5V1.5ZM13.5 1.5L7.5 5.25L1.5 1.5H13.5ZM13.5 10.5H1.5V3L7.5 6.75L13.5 3V10.5Z"
                  fill="#05050D"
                  fillOpacity="0.8"
                />
              </svg>
            </a>
          </div>
          <div className={'w-full flex flex-row mt-2.5'}>
            <p className={'text-ebony_opacity_40 text-xs font-jamjuree'}>
              <a
                className={'underline hover:text-ebony'}
                href={COSUPPORT_URL.PRIVACY}
                target={'_blank'}
                rel="noreferrer"
              >
                Privacy Policy{' '}
              </a>{' '}
              &{' '}
              <a
                className={'underline hover:text-ebony'}
                href={COSUPPORT_URL.TERMS_OF_SERVICES}
                target={'_blank'}
                rel={'noreferrer'}
              >
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
